package com.evoapps.evoshift.domain.usecase.user

import com.evoapps.evoshift.domain.model.User
import com.evoapps.evoshift.domain.model.SensitiveUserData
import com.evoapps.evoshift.domain.repository.UserRepository

data class FullEmployeeDetails(
    val user: User,
    val sensitiveData: SensitiveUserData? // Null jeśli brak uprawnień lub danych
)

class GetEmployeeDetailsUseCase(
    private val userRepository: UserRepository
) {
    /**
     * [includeSensitive]: pay and personal data, which only financial managers and the owner may
     * read (Capability.MANAGE_PAY); without it they are not asked for at all.
     */
    suspend operator fun invoke(targetUserId: String, includeSensitive: Boolean = true): Result<FullEmployeeDetails> {
        return try {
            // 1. Pobierz profil publiczny (User)
            val user = userRepository.getUserProfile(targetUserId).getOrThrow()

            // 2. Dane wrażliwe: brak (null), gdy ich nie ma albo nie wolno ich czytać.
            val sensitive = if (!includeSensitive) null else try {
                userRepository.getSensitiveUserData(targetUserId).getOrNull()
            } catch (e: Exception) {
                null // Brak uprawnień lub brak danych
            }

            Result.success(FullEmployeeDetails(user, sensitive))
        } catch (e: Exception) {
            Result.failure(e)
        }
    }
}